import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpgToJpegConfig } from '@/data/landingConfig/landingJpgToJpegConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpgToJpeg } from './schemaObject';

interface Props {}
const JpgToJpegConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpgToJpeg} />
			<LandingTemplate
				data={landingJpgToJpegConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpgToJpegConverter;
